




























import mixins from 'vue-typed-mixins';
import WorksheetModal from '@/components/worksheet/WorksheetModal.vue';
import WorksheetUtils, { Worksheet } from '@/utils/WorksheetUtils';
import { SurveyGroup } from '@/utils/SurveyUtils';
export default mixins().extend({
  components: {
    WorksheetModal,
  },

  props: {
    value: {
      type: Object as () => SurveyGroup,
    },
    pristine: {
      type: Object as () => SurveyGroup,
    },
  },

  computed: {
    headers() {
      return [
        { text: this.$tc('model.worksheet.name'), value: 'name' },
        { text: this.$tc('model.worksheet.active'), value: 'active' },
      ];
    },
  },

  data(): {
    items?: Worksheet[];
    modal: {
      item?: Partial<Worksheet>;
    };
  } {
    return {
      items: undefined,
      modal: {
        item: undefined,
      },
    };
  },

  async mounted() {
    try {
      this.items = await WorksheetUtils.api.list({
        surveygroupid: this.value.id as number,
      });
    } catch (error) {
      this.$alert.show('mounted', {
        type: 'error',
        messages: this.$handleAPIError(error),
      });
    }
  },

  methods: {
    open(item?: Partial<Worksheet>) {
      if (!item) {
        item = {
          id: undefined,
          name: this.$languageobj(),
          active: false,
          surveygroup: this.value,
          layout: {
            headers: [],
          },
        };
      }
      this.modal.item = item;
    },

    async submit(item?: Worksheet) {
      this.modal.item = undefined; // close modal
      if (item && this.items) {
        const index = this.items.findIndex(
          (worksheet) => worksheet.id === item.id
        );

        let message: string;
        if (index >= 0) {
          this.items[index] = item;
          message = 'validation.success.default';
        } else {
          this.items.push(item);
          message = 'validation.success.add';
        }

        this.$toast.push({
          type: 'success',
          text: this.$languageobj(message, {
            values: [item.name],
          }),
        });
      }
    },

    async remove(item: Worksheet) {
      await this.$confirm(
        this.$i18n.tc('validation.confirmation.delete', 1, [
          this.$translate(item.name),
        ]),
        async () => {
          if (this.items) {
            try {
              this.$alert.hide('remove');

              await WorksheetUtils.api.remove(item.id);

              const index = this.items.findIndex(
                (worksheet) => worksheet.id === item.id
              );
              if (index >= 0) {
                this.items.splice(index, 1);
              }

              this.$toast.push({
                type: 'success',
                text: this.$languageobj('validation.success.delete', {
                  values: [item.name],
                }),
              });
            } catch (error) {
              this.$alert.show('remove', {
                type: 'error',
                messages: this.$handleAPIError(error),
              });
            }
          }
        }
      );
    },
  },
});
